export default "__VITE_ASSET__DxpoDFF$__"